import Pointer from 'ol/interaction/Pointer';

class DragInteraction extends Pointer {
	/**
	 * @type {import('ol/pixel').Pixel}
	 * @private
	 */
	coordinate_ = null;

	/**
	 * @type {string|undefined}
	 * @private
	 */
	cursor_ = 'pointer';

	/**
	 * @type {import('ol/Feature').default}
	 * @private
	 */
	feature_ = null;

	/**
	 * @type {string|undefined}
	 * @private
	 */
	previousCursor_ = undefined;

	/**
	 * @param {import('ol').MapBrowserEvent} e Map browser event.
	 * @returns {boolean} `true` to start the drag sequence.
	 */
	handleDownEvent(e) {
		const feature = e.map.forEachFeatureAtPixel(e.pixel, (f) => f);

		if (feature) {
			this.coordinate_ = e.coordinate;
			this.feature_ = feature;
		}

		return !!feature;
	}

	/**
	 * @param {import('ol').MapBrowserEvent} e Map browser event.
	 */
	handleDragEvent(e) {
		const deltaX = e.coordinate[0] - this.coordinate_[0];
		const deltaY = e.coordinate[1] - this.coordinate_[1];

		const geometry =
			/** @type {import('ol/geom/SimpleGeometry').default} */
			(this.feature_.getGeometry());
		geometry.translate(deltaX, deltaY);

		this.coordinate_[0] = e.coordinate[0];
		this.coordinate_[1] = e.coordinate[1];
	}

	/**
	 * @param {import('ol').MapBrowserEvent} e Event.
	 */
	handleMoveEvent(e) {
		if (this.cursor_) {
			const feature = e.map.forEachFeatureAtPixel(e.pixel, (f) => f);
			const element = e.map.getTargetElement();
			if (feature) {
				if (element.style.cursor !== this.cursor_) {
					this.previousCursor_ = element.style.cursor;
					element.style.cursor = this.cursor_;
				}
			} else if (this.previousCursor_ !== undefined) {
				element.style.cursor = this.previousCursor_;
				this.previousCursor_ = undefined;
			}
		}
	}

	/**
	 * @param {import('ol').MapBrowserEvent} _e Map browser event.
	 * @returns {boolean} `false` to stop the drag sequence.
	 */
	handleUpEvent(_e) {
		this.coordinate_ = null;
		this.feature_ = null;
		return false;
	}
}

export default DragInteraction;
